import req from '../utils/request.js'
const authreq = {}

// 分类树
authreq.catelog = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webArticles/GetIndexArticles', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

authreq.login = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/api/userinfo/Login', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

authreq.reset = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/userCenter/ExchangeToken', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

authreq.gettoken = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/api/sys/login', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 图书馆认证登录
authreq.casLogin = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/api/sys/CasLogin', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

authreq.ssologin = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/api/sys/OAuthLogin', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 图形验证码
authreq.imgcode = function(time) {
  return new Promise((resolve, reject) => {
    req.get(`/api/sys/randomImage/${time}`, {}).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default authreq
